import type { ModulesType } from '@lib/sanity/queries/modules/allModules';
import { MachineLayerType } from '@lib/sanity/queries/modules/machineLayer/types';

export function getFirstMachineLayerData(modules?: ModulesType[]): MachineLayerType | undefined {
  if (!modules || modules.length === 0) {
    return undefined;
  }
  const firstMachineLayer = modules.find((module) => module._type === 'machineLayer');
  if (!firstMachineLayer) {
    return undefined;
  }
  return firstMachineLayer as MachineLayerType;
}
